"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoundedDuration = void 0;
const moment_1 = __importDefault(require("moment"));
const helpers_1 = require("./..");
const constants_1 = require("../../constants");
require("./getFormattedDuration");
const DEFAULT_FORMAT_MAP = {
    day: 'd',
    hour: 'h',
    minute: 'min',
    second: 'sec',
};
const formatDuration = ({ days, seconds, minutes, hours }, formatMap) => {
    if (days) {
        return {
            value: helpers_1.roundToBiggerUnit(hours, days, constants_1.TIME_VALUES.halfFromHourToLess),
            unit: formatMap.day,
        };
    }
    if (hours) {
        return {
            value: helpers_1.roundToBiggerUnit(minutes, hours, constants_1.TIME_VALUES.halfFromMinuteToLess),
            unit: formatMap.hour,
        };
    }
    if (minutes) {
        return {
            value: helpers_1.roundToBiggerUnit(seconds, minutes, constants_1.TIME_VALUES.halfFromSecondToLess),
            unit: formatMap.minute,
        };
    }
    return { value: seconds.toString(), unit: formatMap.second };
};
const getRoundedDuration = ({ durationValue, unit = constants_1.UNIT_OF_TIME.milliseconds, emptyValue = constants_1.EMPTY_TEXT.dash, formatMap = DEFAULT_FORMAT_MAP, } = {}) => {
    let value;
    if (!durationValue || !isFinite(durationValue)) {
        value = { value: emptyValue };
    }
    else {
        const d = moment_1.default.duration(Number(durationValue), unit);
        if (d.asMilliseconds() < 1000) {
            value = { value: '1', unit: formatMap.second };
        }
        else {
            value = formatDuration({
                days: d.days(),
                hours: d.hours(),
                minutes: d.minutes(),
                seconds: d.seconds(),
            }, formatMap);
        }
    }
    return value;
};
exports.getRoundedDuration = getRoundedDuration;
//# sourceMappingURL=getRoundedDuration.js.map